import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const DragIndicator = ({
  className,
  color = '#fff',
  width = 24,
  height = 24
}: SVGProps) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
    >
      <path 
        d="M22 11c-.5523 0-1-.4477-1-1 0-.55228.4477-1 1-1s1 .44772 1 1c0 .5523-.4477 1-1 1ZM22 15c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1ZM18 11c-.5523 0-1-.4477-1-1 0-.55228.4477-1 1-1s1 .44772 1 1c0 .5523-.4477 1-1 1ZM18 15c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1ZM14 11c-.5523 0-1-.4477-1-1 0-.55228.4477-1 1-1s1 .44772 1 1c0 .5523-.4477 1-1 1ZM14 15c-.5523 0-1-.4477-1-1s.4477-1 1-1 1 .4477 1 1-.4477 1-1 1ZM10 11c-.55228 0-1-.4477-1-1 0-.55228.44772-1 1-1 .5523 0 1 .44772 1 1 0 .5523-.4477 1-1 1ZM10 15c-.55228 0-1-.4477-1-1s.44772-1 1-1c.5523 0 1 .4477 1 1s-.4477 1-1 1ZM6 11c-.55228 0-1-.4477-1-1 0-.55228.44772-1 1-1s1 .44772 1 1c0 .5523-.44772 1-1 1ZM6 15c-.55228 0-1-.4477-1-1s.44772-1 1-1 1 .4477 1 1-.44772 1-1 1ZM2 11c-.55228 0-1-.4477-1-1 0-.55228.44772-1 1-1s1 .44772 1 1c0 .5523-.44772 1-1 1ZM2 15c-.55228 0-1-.4477-1-1s.44772-1 1-1 1 .4477 1 1-.44772 1-1 1Z" 
        fill={color}
      />
    </svg>
  );
};
